const slowla = document.querySelector(".sticky-listen-or-watch-live-actions");

if (slowla) {
  const toggleButtons = slowla.querySelectorAll(
    ".slowla__toggles button, .slowla__close-area, .slowla__links .btn"
  );
  [...toggleButtons].forEach((toggleButton) => {
    toggleButton.addEventListener("click", () => {
      slowla.classList.toggle("is-expanded");
      toggleButton.blur();
    });
  });

  const refreshCompact = () => {
    if (window.pageYOffset < window.innerHeight / 2) {
      slowla.classList.remove("is-compact");
    } else {
      slowla.classList.add("is-compact");
    }

    setTimeout(() => {
      refreshCompact();
    }, 333);
  };

  requestAnimationFrame(refreshCompact);
}
